import React from "react";

export default function ActivityFeed({ activityFeed }) {
  if (!activityFeed || activityFeed.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: 32 }}>
      <h2>📈 AI Activity Feed</h2>

      <div style={activityFeedStyle}>
        {activityFeed.map((item, index) => (
          <div key={index} style={activityItemStyle}>
            <div style={{ fontSize: 22 }}>{item.icon}</div>

            <div>
              <p style={{ margin: 0, fontWeight: 700 }}>{item.title}</p>

              <p style={{ margin: "4px 0", color: "#475569" }}>
                {item.detail}
              </p>

              <p style={{ margin: 0, fontSize: 12, color: "#64748b" }}>
                {new Date(item.date).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const activityFeedStyle = {
  display: "grid",
  gap: 12
};

const activityItemStyle = {
  display: "flex",
  gap: 12,
  padding: "14px",
  borderRadius: "12px",
  background: "#f8fafc",
  border: "1px solid #e5e7eb"
};